// extracted by mini-css-extract-plugin
export default {"deleteSbatGroupButton":"DeleteSbatGroupButton_deleteSbatGroupButton__lWXJw"};